enum MULTIPLE_COUNTRY_CODES_COUNTRIES {
  DOMINICAN_REPUBLIC = 'Dominican Republic',
}
const COUNTRIES_WITH_MULTIPLE_COUNTRY_CODE = Object.values(
  MULTIPLE_COUNTRY_CODES_COUNTRIES
);

const CODES_OF_MULTIPLE_COUNTRIES: { [k in MULTIPLE_COUNTRY_CODES_COUNTRIES]: string[] } =
  {
    [MULTIPLE_COUNTRY_CODES_COUNTRIES.DOMINICAN_REPUBLIC]: ['+1 809', '+1 829', '+1 849'],
  };

const MAX_OTP_RESEND_COUNT = 1;

export {
  COUNTRIES_WITH_MULTIPLE_COUNTRY_CODE,
  CODES_OF_MULTIPLE_COUNTRIES,
  MULTIPLE_COUNTRY_CODES_COUNTRIES,
  MAX_OTP_RESEND_COUNT,
};
